





























































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator'
import UserQuestionList from '../organisms/UserQuestionList.vue'
import UserQuestionFormView from '../organisms/UserQuestionFormView.vue'
import ReviewDialog from '../organisms/ReviewDialog.vue'
import ReviewEditDialog from '../organisms/ReviewEditDialog.vue'
import markdownParser from '../../../../helpers/markdown-parser'
import CommentContainer from '../organisms/CommentContainer.vue'
import UserQuestionDetailModal from '../organisms/UserQuestionDetailModal.vue'
import { mixins } from 'vue-class-component'
import CourseMyDetailMixin from './CourseMyDetailMixin'
import UserQuestion from '../../../api/v2/models/user_question'
import IframeLoading from '../atoms_molecules/IframeLoading.vue'
import TeacherView from '../atoms_molecules/TeacherView.vue'
import MesageContainer from '../organisms/MesageContainer.vue'
import LiveChat from "../organisms/LiveChat.vue";

@Component({
  components: {
    LiveChat,
    UserQuestionList,
    UserQuestionFormView,
    ReviewDialog,
    ReviewEditDialog,
    CommentContainer,
    UserQuestionDetailModal,
    IframeLoading,
    TeacherView,
    MesageContainer,
  }
})
export default class CourseMyDetailMobile extends mixins(CourseMyDetailMixin) {
  currentQuestion: UserQuestion | null = null;
  questionMode: 'list' | 'show' | 'new' = 'list'
  newQuestionCreatedFlag = false

  onClickQuestion(question: UserQuestion) {
    this.currentQuestion = question
    this.questionMode = 'show'
    this.newQuestionCreatedFlag = false
  }

  onClickNewQuestion() {
    this.questionMode = 'new'
    this.newQuestionCreatedFlag = false
  }

  onBackQuestionList() {
    this.currentQuestion = null
    this.questionMode = 'list'
    this.newQuestionCreatedFlag = false
  }

  mounted() {
    this.$root.$on('questionCreated', (question: UserQuestion) => {
      this.currentQuestion = question
      this.questionMode = 'show'
      this.newQuestionCreatedFlag = true
    })
  }
}
